module.exports = __webpack_public_path__ + "img/dzg_kr.1a433b0e.png";